import en from "./en";
import ja from "./ja";

export const useLocale = () => {
  const locale = process.env.LANGUAGE || "ja";
  const t = locale === "en" ? en : ja;
  return { locale, t };
};
